module.exports = __webpack_public_path__ + "img/img42.08b521e9.png";